import { Component, OnInit } from '@angular/core';
import { ClientService } from '@app/core/services/client.service';
import { MessageState } from '@app/shared/models/message';
import { MessagingEventData, MessagingWebSocketService } from '@app/core/services/web-socket/messaging-web-socket.service';
import { Observable } from 'rxjs';
import { BaseWithBundleComponent } from '../base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { MessageDialogComponent } from '@app/shared/dialogs/message-dialog/message-dialog.component';

@Component({
    selector: 'message-service',
    templateUrl: './message-service.component.html',
    styleUrls: ['./message-service.component.scss']
})
export class MessageServiceComponent extends BaseWithBundleComponent implements OnInit {

    public newMessageCount: number;

    constructor(
            public componentServiceBundle: ComponentServiceBundle,
            private clientService: ClientService,
            private messagingWebSocketService: MessagingWebSocketService) {
        super(componentServiceBundle);
        this._idPrefix = 'envelope.';
    }

    public ngOnInit() {
        this.newMessageCount = 0;
        this.subscribeToMessagingWebSocket();

        this.clientService.getMessages().subscribe((messages) => {
            this.newMessageCount = messages.items.filter((m) => {
                return m.state === MessageState.NEW;
            }).length;
        });
    }

    private subscribeToMessagingWebSocket(): void {
        this.subscriptions.push(
                this.messagingWebSocketService.socket
                    .subscribe((push: MessagingEventData) => {
            this.newMessageCount = push.data.new_messages_count;
        }));
    }

    public showMessages() {
        (new Observable((observer) => {
            const dialogRef = this.dialog.open(MessageDialogComponent, {
                hasBackdrop: true,
                width: '85%',
                data: {
                    title: 'fileMeta.filename',
                    file: 'fileMeta',
                }
            });
    
            dialogRef.afterClosed().subscribe(result => {
                observer.next(result);
                observer.complete();
            });

            return {
                unsubscribe() {
                }
            };
        })).subscribe((cleared) => {
            if (cleared) {
                this.newMessageCount = 0;
            }
        });
    }
}
